<template>


  <div class="animated fadeIn" id="areaImprimir">




    <b-row>
      <b-col>
        <b-img  :src="img" left fluid style="max-height: 100px; max-width: 250px" alt="Responsive image"  class="rounded pb-0"></b-img>
        <h1 class="text-right">INSTRUCTIVO EMBARQUE #{{shipment.boarding_number}}</h1>
        <p class="text-right mt-1 mb-1">Fecha Embarque: {{shipment.shipment_date | moment }}</p>
        <p class="text-right mt-1 mb-1">Tipo Embarque: {{shipment.shipment_type.name }}</p>
        <p class="text-right mt-1 mb-1">País Destino: {{shipment.country.name }}</p>
        <a href="#" class="float-right text-black-50" @click="descargarPDF"><i class="fa fa-download"></i></a>
      </b-col>
    </b-row>

     <b-row class="border-bottom border-top bg-gray-100 font-weight-bold">
      <b-col>
        <p class="text-center mt-1 mb-1 ">Datos Exportadora</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
         <b>{{shipment.exporter_company.company_name}}</b><br>
         Rut: {{shipment.exporter_company.company_number}}<br>
         {{shipment.exporter_company.address1}}, {{shipment.exporter_company.address2}} <br>
      </b-col>
      <b-col class="text-right">
         {{shipment.exporter_company.contact_name}}<br>
         {{shipment.exporter_company.contact_email}}<br>
        {{shipment.exporter_company.contact_phone}}
      </b-col>
    </b-row>

    <b-row class="border-bottom mt-2 border-top bg-gray-100 font-weight-bold">
      <b-col>
        <p class="text-center mt-1 mb-1 ">Datos Agente Aduanas</p>
      </b-col>
      <b-col>
        <p class="text-center mt-1 mb-1 ">Datos Embarcador</p>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b>Razón Social</b>: {{shipment.custom_agent_company.company_name}}<br>
          <b>RUT</b>: {{shipment.custom_agent_company.company_number}}<br>
          <b>Dirección</b>: {{shipment.custom_agent_company.address1}}, {{shipment.custom_agent_company.address2}} <br>
          <b>Contacto</b>: {{shipment.custom_agent_company.contact_name}}<br>
          <b>Correo</b>: {{shipment.custom_agent_company.contact_email}}<br>
          <b>Teléfono</b>: {{shipment.custom_agent_company.contact_phone}}
      </b-col>
      <b-col>
        <b>Razón Social</b>: {{shipment.shipper_company.company_name}}<br>
        <b>RUT</b>: {{shipment.shipper_company.company_number}}<br>
        <b>Dirección</b>: {{shipment.shipper_company.address1}}, {{shipment.shipper_company.address2}} <br>
        <b>Contacto</b>: {{shipment.shipper_company.contact_name}}<br>
        <b>Correo</b>: {{shipment.shipper_company.contact_email}}<br>
        <b>Teléfono</b>:{{shipment.shipper_company.contact_phone}}
      </b-col>
    </b-row>

    <b-row class="mt-2 border-bottom border-top bg-gray-100 font-weight-bold">
      <b-col>
        <p class="text-center mt-1 mb-1 ">Datos Consignatario</p>
      </b-col>
      <b-col>
        <p class="text-center mt-1 mb-1 ">Datos Notificador</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b>Razón Social</b>: {{shipment.consignee_company.company_name}}<br>
        <b>RUT</b>: {{shipment.consignee_company.company_number}}<br>
        <b>Dirección</b>: {{shipment.consignee_company.address1}}, {{shipment.consignee_company.address2}} <br>
        <b>Contacto</b>: {{shipment.consignee_company.contact_name}}<br>
        <b>Correo</b>: {{shipment.consignee_company.contact_email}}<br>
        <b>Teléfono</b>:{{shipment.consignee_company.contact_phone}}
      </b-col>
      <b-col>
        <b>Razón Social</b>: {{shipment.notify_company.company_name}}<br>
        <b>RUT</b>: {{shipment.notify_company.company_number}}<br>
        <b>Dirección</b>: {{shipment.notify_company.address1}}, {{shipment.notify_company.address2}} <br>
        <b>Contacto</b>: {{shipment.notify_company.contact_name}}<br>
        <b>Correo</b>: {{shipment.notify_company.contact_email}}<br>
        <b>Teléfono</b>:{{shipment.notify_company.contact_phone}}
      </b-col>
    </b-row>

    <b-row class="mt-2 border-bottom border-top bg-gray-100 font-weight-bold">
      <b-col>
        <p class="text-center mt-1 mb-1 ">Datos del Embarque</p>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b>Nave</b>: {{shipment.vessel}}<br>
        <b>Container</b>: {{shipment.containers}}<br>
        <b>Naviera</b>: {{shipment.shipping_line.name }}<br>
        <b>Puerto de Carga</b>: {{shipment.loading_port == null ? "N/A" : shipment.loading_port.name}}<br>
        <b>Puerto de Destino</b>: {{shipment.destination_port.name}}<br>
        <b>SPS</b>: {{shipment.sps}}<br>
        <b>Booking Number</b>: {{shipment.booking_number}}<br>
        <b>Depósito</b>: {{shipment.depot}}<br>
        <b>Sello</b>: {{shipment.seal_number}}<br>
      </b-col>
      <b-col >
        <b>Empresa Transporte</b>: {{shipment.transport_company}}<br>
        <b>Dirección</b>: {{shipment.plant_company.company.address1}}, {{shipment.plant_company.company.address2}}<br>
        <b>Citación en planta</b>: {{shipment.shipment_date | momenttime }}<br>
        <b>Fecha de Carga</b>: {{shipment.shipment_date | moment}}<br>
        <b>Fecha Apilamiento</b>: {{shipment.stacking_date | moment }}<br>
        <b>Fecha de corte</b>: {{shipment.cut_date | moment}}<br>
        <b>ETD</b>: {{shipment.etd | moment}}<br>
        <b>ETA</b>: {{shipment.eta | moment}}<br>
        <b>Planta</b>: {{shipment.plant == null ? "N/A" : shipment.plant_company.company.company_name}}<br>
        <b>Late arrival</b>: {{shipment.late_arrival }}

      </b-col>
      <b-col>
        <b>Modalidad de Venta</b>: {{shipment.sale_mode}}<br>
        <b>Modalidad de Pago</b>: {{shipment.payment_form}}<br>
        <b>Condicion de Venta</b>: {{shipment.sale_clause}}<br>
        <b>Modalidad de Flete</b>: {{shipment.freight_mode}}<br>
        <b>Cambio</b>: {{shipment.currency}}<br>
        <b>PO</b>: {{shipment.po_number}}<br>
        <b>BL</b>: {{shipment.bill_loading}}<br>
        <b>DUS</b>: {{shipment.dus_number}}<br>
      </b-col>
    </b-row>

     <b-row class="mt-2 border-bottom border-top bg-gray-100 font-weight-bold">
      <b-col>
        <p class="text-center mt-1 mb-1 ">Datos Técnicos de la Carga</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b>Ventilación</b>: {{shipment.ventilation}}<br>
        <b>Temperatura</b>: {{shipment.temperature}}<br>
      </b-col>
      <b-col>
        <b>Atmósfera</b>: {{shipment.atmosphere}}<br>
        <b>Gases</b>: {{shipment.gas}}<br>
      </b-col>
    </b-row>

    <b-row class="mt-2 border-bottom bor border-top bg-gray-100 font-weight-bold">
      <b-col>
        <p class="text-center mt-1 mb-1 ">Detalle de la Carga</p>
      </b-col>
    </b-row>
    <b-row class="font-weight-bold mt-2">
      <b-col>
        <p class="m-0 p-0 text-center">Producto</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">Variedad</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">Formato</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">Pallets</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">Cajas</p>
      </b-col>
<!--      <b-col>-->
<!--        <p class="m-0 p-0 text-center">Precio</p>-->
<!--      </b-col>-->
      <b-col>
        <p class="m-0 p-0 text-center">KN</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">KB</p>
      </b-col>
    </b-row>
    <b-row v-for="row in shipment.shipment_detailed" class="border-top">
      <b-col>
        <p class="m-0 p-0 text-center">{{row.product.name}}</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">{{row.variety.name}}</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">{{row.container.name}}</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">{{row.pallet_quantity}}</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">{{row.box_quantity}}</p>
      </b-col>
<!--      <b-col>-->
<!--        <p class="m-0 p-0 text-center">{{row.price_per_box}}</p>-->
<!--      </b-col>-->
      <b-col>
        <p class="m-0 p-0 text-center">{{row.net_weight}}</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">{{row.gross_weight}}</p>
      </b-col>
    </b-row>
    <b-row class="border-top font-weight-bold">
      <b-col>
        <p class="m-0 p-0 text-center">TOTAL:</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center"></p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center"></p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">{{pallet_quantity}}</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">{{box_quantity}}</p>
      </b-col>
<!--      <b-col>-->
<!--        <p class="m-0 p-0 text-center"></p>-->
<!--      </b-col>-->
      <b-col>
        <p class="m-0 p-0 text-center">{{net_weight}}</p>
      </b-col>
      <b-col>
        <p class="m-0 p-0 text-center">{{gross_weight}}</p>
      </b-col>
    </b-row>

    <b-row class="mt-2 border-bottom border-top bg-gray-100 font-weight-bold">
      <b-col>
        <p class="text-center mt-1 mb-1 ">Notas y Observaciones</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p class="text-center">{{shipment.note}}</p>
      </b-col>
    </b-row>





</div>












 
</template>



<script>

import html2pdf from 'html2pdf.js'
 import moment from 'moment';

export default {
  name: "ReportInstructivoEmbarqueMaritimo",
  created() {
  },
   props: [
    "idBording",
    "shipment",

   ],
  data() {
    return {
    pallet_quantity:0,
    box_quantity:0,
    gross_weight:0,
    net_weight:0,
    shipment_detailed:[],
    current_date:moment(new Date()).format('DD-MM-YYYY HH:mm'),
    };
  },
    filters: {
        moment: function (date) {
          return moment(date).format('DD-MM-YYYY');
        },
        momenttime: function (date) {
            return moment(date).format('DD-MM-YYYY HH:mm');
          }
      },
  methods: {
     
    printDiv: function() {

   
      const prtHtml = document.getElementById('areaImprimir').innerHTML;


      let stylesHtml = '';
  
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }


      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();

    },
     descargarPDF: function() {

 var element = document.getElementById('areaImprimir').innerHTML;

 var opt = {
  margin:       0.25,
  filename:     'Instructivo Embarque #'+this.shipment.boarding_number+'.pdf',
  jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
};
 
 html2pdf(element,opt);
  
    },
     calcular: function() {


    this.pallet_quantity=0;
    this.box_quantity=0;
    this.gross_weight=0;
    this.net_weight=0;


      this.shipment_detailed= this.shipment.shipment_detailed;

      for (var indice in this.shipment_detailed) 
      {

        this.pallet_quantity+= parseFloat(this.shipment_detailed[indice].pallet_quantity);
        this.box_quantity+= parseFloat(this.shipment_detailed[indice].box_quantity);
        this.gross_weight+= parseFloat(this.shipment_detailed[indice].gross_weight);
        this.net_weight+= parseFloat(this.shipment_detailed[indice].net_weight);

      }

        this.pallet_quantity= this.pallet_quantity;
        this.box_quantity= this.box_quantity;
        this.gross_weight= this.gross_weight.toFixed(2)
        this.net_weight= this.net_weight.toFixed(2)


 
  
  },

  },
    mounted() {



  

   },
   beforeMount() {



   }
};
</script>

<style lang="scss">
  
   table { page-break-inside:auto }
   tr    { page-break-inside:avoid; page-break-after:auto }

   #dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}

</style>
